<app-variant-tab-header
  [variant]="variant"
  [statusesRefData]="statusesRefData"
  [formVariant]="formVariant"
  (resetForm)="initFormGroup(variant)"
  (saveVariant)="saveVariant()"
  (deleteVariant)="deleteVariant()"
></app-variant-tab-header>

<app-variant-tab-body
  [variant]="variant"
  [formVariant]="formVariant"
  [yieldUnits]="yieldUnits"
  [marketingFoods]="marketingFoods"
  [applianceGroupsRefData]="applianceGroupsRefData"
  [utensilsRefData]="utensilsRefData"
></app-variant-tab-body>
